import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Row, Col, Alert, Button } from 'react-bootstrap'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { badges as endpoints } from '@URLS'
import { LoadingSpinner, WizardSteps } from '../../components'
import { linkPaths, OBJECT_ID } from '../urls'
import { BadgeName } from './BadgeName'
import { BadgeReviewImage } from './BadgeReviewImage'
import { ReviewContentLayout } from './ReviewContentLayout'

export function Review() {
  const [state, dispatch] = useStateValue()
  const history = useHistory()
  const [isFinishing, setIsFinishing] = useState(false)

  useEffect(() => {
    return () => dispatch({ type: 'SET_ERRORS', errors: [] })
  }, [])

  const goBack = e => {
    e.preventDefault()
    history.push(linkPaths.requirements)
  }

  const finish = async e => {
    e.preventDefault()
    setIsFinishing(true)
    const badgePayload = {
      ...state.badgeInfo,
      chapters: state.badgeInfo.selectedChapters,
      assessments: state.badgeInfo.selectedAssessments,
      videos: state.badgeInfo.selectedVideos,
      passingScore: state.badgeInfo.passingScore,
    }

    const handleError = err => {
      console.error('Error saving badge', err)
      if (err.message === 'Network Error') {
        dispatch({
          type: 'SET_ERRORS',
          errors: [err.message + ', icon file(s) may be too large'],
        })
      } else {
        dispatch({ type: 'SET_ERRORS', errors: [err.message] })
      }
    }

    try {
      if (state.badgeInfo.retrievedEditData) {
        await client.put(endpoints.update({ id: OBJECT_ID }), { badgeInfo: badgePayload })
      } else {
        await client.post(endpoints.create(), { badgeInfo: badgePayload })
      }
      dispatch({ type: 'FINISH_BADGE' })
    } catch (err) {
      handleError(err)
    }
  }

  const formatErrors = () => {
    if (state.errors.length === 0) {
      return
    }
    return (
      <Container>
        <Row>
          <Col xs={24} sm={12} smOffset={6}>
            <Alert variant="danger">
              <ul>
                {state.errors.map((msg, i) => (
                  <li key={i}>{msg}</li>
                ))}
              </ul>
            </Alert>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <div>
      <WizardSteps
        edit={state.badgeInfo.retrievedEditData}
        step={3}
        linkPaths={linkPaths}
        heading="Badge"
        subHeading="Review"
      />
      <div className="review_container">
        {formatErrors()}
        <div className="flex_container">
          <div id="badge_review_box">
            <div className="text-center" id="badge_name">
              <BadgeName disable />
            </div>
            <div id="images">
              <div className="image" id="incompleteImage">
                Incomplete Icon
                <BadgeReviewImage
                  imageLoaded={state.badgeInfo.incompleteImageLoaded}
                  image={state.badgeInfo.incompleteImage}
                  imageName={state.badgeInfo.incompleteImageName}
                  imageType="Incomplete"
                />
              </div>
              <div className="image" id="completeImage">
                Complete Icon
                <BadgeReviewImage
                  imageLoaded={state.badgeInfo.completeImageLoaded}
                  image={state.badgeInfo.completeImage}
                  imageName={state.badgeInfo.completeImageName}
                  imageType="Complete"
                />
              </div>
            </div>
          </div>
          <ReviewContentLayout />
        </div>
        <div className="btn_container">
          <Button variant="primary" onClick={goBack}>
            Back
          </Button>
          <Button
            variant="primary"
            disabled={state.errors.length > 0}
            onClick={finish}
          >
            <span>Finish</span>{' '}
            {isFinishing && state.errors.length === 0 ? (
              <LoadingSpinner
                style={{ fontSize: '1em', color: 'white' }}
                outerClass={'inline'}
              />
            ) : (
              ''
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
